import * as React from "react";
import { Button } from "../../button/button.mjs";
import { Search } from "../../form/search/search.mjs";
const HeaderSearch = (props) => {
  const { detailedViewButton, onSubmit, id = "header-search", ...rest } = props;
  return /* @__PURE__ */ React.createElement(
    Search,
    {
      ...rest,
      onSubmit,
      className: "header__search",
      id,
      hideLabel: "no-break",
      placeholderLabel: true,
      suggestionClassName: "header__search-suggestion",
      offsetY: 5,
      suggestionContent: /* @__PURE__ */ React.createElement(Button, { ...detailedViewButton, link: true, className: "header__search-suggestion-button", iconRight: "#arrow-right" }),
      formAttributes: {
        ...rest.formAttributes,
        role: "search"
      }
    }
  );
};
export {
  HeaderSearch
};
